import t, { Component as e } from "react";
import n from "../../../utils/DomHandler.js";
import i from "../../api/KaseyaUI.js";
function o(t) {
  if (void 0 === t) throw ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function r(t, e) {
  for (var n = 0; n < e.length; n++) {
    var i = e[n];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
  }
}
function u(t, e, n) {
  return e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
function a(t) {
  return (a = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  })(t);
}
function s(t, e) {
  return (s = Object.setPrototypeOf || function (t, e) {
    return t.__proto__ = e, t;
  })(t, e);
}
var c = function (e) {
  !function (t, e) {
    if ("function" != typeof e && null !== e) throw TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
      constructor: {
        value: t,
        writable: !0,
        configurable: !0
      }
    }), e && s(t, e);
  }(h, e);
  var c,
    l,
    f,
    p = (c = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct || Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }(), function () {
      var t,
        e,
        n = a(h);
      if (c) {
        var i = a(this).constructor;
        e = Reflect.construct(n, arguments, i);
      } else e = n.apply(this, arguments);
      return (t = e) && ("object" == (t && "undefined" != typeof Symbol && t.constructor === Symbol ? "symbol" : typeof t) || "function" == typeof t) ? t : o(this);
    });
  function h() {
    var t;
    return !function (t, e) {
      if (!(t instanceof e)) throw TypeError("Cannot call a class as a function");
    }(this, h), t = p.apply(this, arguments), u(o(t), "ink", void 0), u(o(t), "target", void 0), u(o(t), "onMouseDown", function (e) {
      if (t.ink && "none" !== getComputedStyle(t.ink, null).display) {
        if (n.removeClass(t.ink, "p-ink-active"), !n.getHeight(t.ink) && !n.getWidth(t.ink)) {
          var i = Math.max(n.getOuterWidth(t.target), n.getOuterHeight(t.target));
          t.ink.style.height = i + "px", t.ink.style.width = i + "px";
        }
        var o = n.getOffset(t.target),
          r = e.pageX - o.left + document.body.scrollTop - n.getWidth(t.ink) / 2,
          u = e.pageY - o.top + document.body.scrollLeft - n.getHeight(t.ink) / 2;
        t.ink.style.top = u + "px", t.ink.style.left = r + "px", n.addClass(t.ink, "p-ink-active");
      }
    }), t;
  }
  return l = [{
    key: "getTarget",
    value: function value() {
      return this.ink && this.ink.parentElement;
    }
  }, {
    key: "bindEvents",
    value: function value() {
      this.target && this.target.addEventListener("mousedown", this.onMouseDown);
    }
  }, {
    key: "unbindEvents",
    value: function value() {
      this.target && this.target.removeEventListener("mousedown", this.onMouseDown);
    }
  }, {
    key: "onAnimationEnd",
    value: function value(t) {
      n.removeClass(t.currentTarget, "p-ink-active");
    }
  }, {
    key: "componentDidMount",
    value: function value() {
      this.ink && (this.target = this.getTarget(), this.bindEvents());
    }
  }, {
    key: "componentDidUpdate",
    value: function value() {
      this.ink && !this.target && (this.target = this.getTarget(), this.bindEvents());
    }
  }, {
    key: "componentWillUnmount",
    value: function value() {
      this.ink && (this.target = null, this.unbindEvents());
    }
  }, {
    key: "render",
    value: function value() {
      var e = this;
      return i.ripple && t.createElement("span", {
        ref: function ref(t) {
          return e.ink = t;
        },
        className: "p-ink",
        onAnimationEnd: this.onAnimationEnd
      });
    }
  }], r(h.prototype, l), f && r(h, f), h;
}(e);
export { c as Ripple };